import axios from "axios";

export default defineNuxtPlugin((nuxtApp) => {
  const api = axios.create({
    baseURL: useRuntimeConfig().public.API_SERVER,
  });

  nuxtApp.provide("axios", api);
});
